<template>
  <div class="calico-toggle">
    <label
      :class="{
        checked,
        disabled
      }"
      @click.stop
    >
      <input
        type="checkbox"
        :checked="checked"
        :disabled="disabled"
        v-bind="filteredAttrs"
        v-on="filteredListeners"
        @change="handleChange"
      >

      <span class="toggle-track">
        <span class="toggle-thumb" />
      </span>

      <slot />
    </label>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'CalicoToggle',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const filteredAttrs = computed(() => {
      const { ...restAttrs } = attrs;
      return restAttrs;
    });

    const filteredListeners = computed(() => {
      const listeners = { ...attrs };
      delete listeners.onUpdateModelValue;
      return listeners;
    });

    const checked = computed(() => props.modelValue === true);

    const handleChange = (event) => {
      emit('update:modelValue', event.target.checked);
    };

    return {
      filteredAttrs,
      filteredListeners,
      checked,
      handleChange,
    };
  },
};
</script>

<style scoped lang="scss">
.calico-toggle {
  label {
    @include inline-space($space-small);
    align-items: center;
    cursor: pointer;

    input {
      display: none;
    }

    .toggle-track {
      @include inline-space($space-small);
      width: 42px;
      height: 26px;
      padding: $space-xsmall;
      box-sizing: border-box;
     
      align-items: center;
      justify-content: flex-start;

      border-radius: $radius-round;
      border: $border-width-default solid $color-black;
      background: $color-white;

      transition: background 0.2s ease, border-color 0.3s ease;
    }

    .toggle-thumb {
      width: 18px;
      height: 18px;
      border-radius: $radius-round;
      background: $color-black;

      transition: background 0.3s ease;
    }

    &.checked {
      .toggle-track {
        background: $color-black;
        justify-content: flex-end;
      }

      .toggle-thumb {
        background: $color-white;
      }
    }

    &.disabled {
      cursor: default;

      .toggle-track {
        border-color: $color-neutral-light;
        background: $color-white;
      }

      .toggle-thumb {
        background: $color-neutral-light;
      }
    }
  }
}

</style>